'use strict';

var withShape = require('../../../_virtual/withShape.js_commonjs-exports.js');
require('./and.js');
require('./shape.js');
var shape = require('../../../_virtual/shape.js_commonjs-exports2.js');
var and = require('../../../_virtual/and.js_commonjs-exports.js');

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = withShape;

var _and = _interopRequireDefault(and.__exports);

var _shape = _interopRequireDefault(shape.__exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function withShape(type, shapeTypes) {
  if (typeof type !== 'function') {
    throw new TypeError('type must be a valid PropType');
  }

  var shapeValidator = (0, _shape["default"])(shapeTypes);
  return (0, _and["default"])([type, shapeValidator], 'withShape');
}

}(withShape.__exports));
